import React, { useState } from 'react';
import StaffCard from './sections/StaffCard';
import StaffRoleTable from './sections/StaffRoleTable';

/**
 * Main Staff Management Component
 * 
 * Refactored to use improved components with better architecture:
 * - Cleaner separation of concerns
 * - Reusable components and utilities
 * - Better error handling and loading states
 * - Improved maintainability
 * - Shared activeTab state between StaffCard and TabbedStaffTable
 */
const Staff = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-8">
        <div className='flex flex-col gap-6'>
          <StaffCard activeTab={activeTab} />
          <StaffRoleTable activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
      </div>
    </div>
  );
};

export default Staff;
